import { Link } from '@tanstack/react-router';

import type { BusinessDetail } from '../api/schemas';
import { minuteOfDay, shortClock } from '../lib/calendarDay';
import { seatsTaken, type ClassBlock } from '../lib/classCalendarDay';
import { serviceName } from '../lib/useBusiness';
import { blockStyle, SHORT_BLOCK_MIN } from './calendarBlock';

type ClassCalendarEventProps = {
  block: ClassBlock;
  business: BusinessDetail | undefined;
  tone: number;
};

/** One class on a studio's calendar: when, what, and how full; it opens the class list. */
export function ClassCalendarEvent({ block, business, tone }: ClassCalendarEventProps) {
  const session = block.item;
  const minutes = block.endMin - block.startMin;
  const start = minuteOfDay(session.startsAt);
  const range = `${shortClock(start)} a ${shortClock(start + minutes)}`;
  const name = serviceName(business, session.serviceId);
  const taken = seatsTaken(session);
  const isFull = taken >= session.capacity;
  const seats = `${taken} de ${session.capacity}`;
  const spoken = `${range}, ${name}, ${isFull ? 'llena, ' : ''}${seats}`;
  return (
    <Link
      to="/clases"
      className="cal-event"
      data-tone={tone}
      data-full={isFull || undefined}
      data-short={minutes < SHORT_BLOCK_MIN || undefined}
      style={blockStyle(block)}
      aria-label={spoken}
    >
      <span className="cal-event-time">{range}</span>
      <span className="cal-event-name">{name}</span>
      <span className="cal-event-service">{isFull ? `${seats} · Llena` : seats}</span>
    </Link>
  );
}
